import { formatLongDay } from '~/utils/date/date';
import { IArchivedMedicaidPlan } from '~/services/api/medicaidPlan/types';

const formatActivePeriod = ({ effectiveDate, expirationDate }: IArchivedMedicaidPlan): string =>
  [effectiveDate, expirationDate]
    .filter((day): day is string => !!day)
    .map(formatLongDay)
    .join(' - ');

export default formatActivePeriod;
